import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { UtilsService } from '../shared/utils.service';

@Injectable({
  providedIn: 'root'
})
export class ChildDistributorGuardService {

  constructor(private authService: AuthService, private router: Router, private utils: UtilsService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    let canActivate;
    if (this.authService.getUserData().type === this.utils.userTypes.DistributorChild && this.router.url.indexOf('distributor-users')) {
      canActivate = false;
    } else if (this.authService.getUserData().type === this.utils.userTypes.Distributor && this.router.url.indexOf('distributor-users')) {
      canActivate = true;
    }
    if (!canActivate) {
      this.router.navigate(['/dashboard']);
    }
    return canActivate;
  }
}
